module.exports = __webpack_public_path__ + "static/img/goal-07.affead6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/goal-07.png
// module id = ZMZz
// module chunks = 2